/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ReactivateRequestBillingCadence = typeof ReactivateRequestBillingCadence[keyof typeof ReactivateRequestBillingCadence];


export const ReactivateRequestBillingCadence = {
  monthly: 'monthly',
  annual: 'annual',
} as const;
